import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { API_BASE_URL, APP_PREFIX_PATH, AUTH_PREFIX_PATH, AUTHENTICATED_ENTRY,LIVE_STREAM_ENTRY } from 'configs/AppConfig'
import ViewService from 'services/ViewService';
import { message } from 'antd';

const PublicRoute = () => {
	const companyId= localStorage.getItem("companyId");
    const website= localStorage.getItem("website");
	const params= new URLSearchParams(window.location.search);
	const { token } = useSelector(state => state.auth)

	const handleAcceptMigration = async (shop, shopify_state)=>{
		try {
			const data= {
				shop_domain: shop,
				shopify_state
			}
			const response = await ViewService.acceptMigration(data);
			localStorage.setItem("x_request_source","SHOPIFY-APP");
            // localStorage.setItem("shop_domain",true);
			return window.open(`${APP_PREFIX_PATH}/dashboards/default`,"_self");
		} catch (error) {
			message.error(error?.response?.data?.message || "Error in accepting Migration");
			setTimeout(()=>{
				window.open(`${APP_PREFIX_PATH}/dashboards/default`,"_self");
			},2000)
		}
	}

	const handleAcceptAmazonConnection = async (code, selling_partner_id)=>{
		try {
			const data= {
				selling_partner_id: selling_partner_id,
				spapi_oauth_code: code
			}
			await ViewService.connectAmazonAccount(data);
			message.success("Account Connected Successfully.");
			return window.open(`${APP_PREFIX_PATH}/dashboards/default`,"_self");
		} catch (error) {
			message.error("error in connecting account, please try again.");
			return window.open(`${APP_PREFIX_PATH}/dashboards/default`,"_self");
		}
	}

	if(window.location.href.includes("/influencer")&&params.has("token")){
		if(token){
			return window.open(`${APP_PREFIX_PATH}/live-call/stream/schedule?token=${params.get("token")}&onboarded=influencer`,"_self");
		}
		else{
			return window.open(`${AUTH_PREFIX_PATH}/login?token=${params.get("token")}&onboarded=influencer`,"_self");
		}
	}
	if(window.location.href.includes("/aggregator")&&params.has("token")){
		if(token){
			return window.open(`${APP_PREFIX_PATH}/dashboards/default?token=${params.get("token")}&onboarded=aggregator`,"_self");
		}
		else{
			return window.open(`${AUTH_PREFIX_PATH}/login?token=${params.get("token")}&onboarded=aggregator`,"_self");
		}
	}
	if(window.location.href.includes("/amazon")){
		if(token){
			if(params.has("amazon_callback_uri")){
				const amazon_callback_uri= params.get("amazon_callback_uri");
				const decodedAmazonUrl= decodeURIComponent(amazon_callback_uri);
				const indexOfAmpersand = decodedAmazonUrl.indexOf('&');
				const redirect_uri= `?redirect_uri=${API_BASE_URL}/auth/amazon`
				// Add the redirect_uri before the first '&', or at the end if '&' is not found
				const updatedDecodedAmazonUrl = indexOfAmpersand !== -1 ? decodedAmazonUrl.slice(0, indexOfAmpersand) + redirect_uri + decodedAmazonUrl.slice(indexOfAmpersand) : decodedAmazonUrl + redirect_uri;
				return window.open(updatedDecodedAmazonUrl, "_self");
			}
			else{
				if(params.has("spapi_oauth_code") && params.has("selling_partner_id")){
					const code= params.get("spapi_oauth_code");
					const selling_partner_id= params.get("selling_partner_id");
					handleAcceptAmazonConnection(code, selling_partner_id);
				}
			}
		}
		else{
			return window.open(`${AUTH_PREFIX_PATH}/login`,"_self");
		}
	}
	else{
		if(token){
			if(params.has("shop") && params.has("shopify_state")){
				const shop= params.get("shop");
				const shopify_state= params.get("shopify_state");
				handleAcceptMigration(shop, shopify_state);
			}
			else{
				return <Navigate to={companyId=="2aebbd0722"||website=="influencer"?LIVE_STREAM_ENTRY:AUTHENTICATED_ENTRY} />
			}
		}
		else{
			return <Outlet/>
		}
	}
	
}

export default PublicRoute